import React from "react";
import s from "./MessagingMeta.module.scss";
import { Skeleton } from "antd";
type PropType = {
  totalSends: number;
  deliveries: number;
  failures: number;
  responsesRate: string;
  loading: boolean;
};
function MessagingMeta({
  deliveries,
  failures,
  loading,
  responsesRate,
  totalSends,
}: PropType) {
  if (loading) {
    return (
      <div className={s.wrapper}>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
      </div>
    );
  }
  return (
    <div className={s.wrapper}>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Total sends</h5>
        <p className={s.statNumber}>{totalSends.toLocaleString()}</p>
      </div>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Deliveries</h5>
        <p className={s.statNumber}>{deliveries.toLocaleString()}</p>
      </div>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Failures</h5>
        <p className={s.statNumber}>{failures.toLocaleString()}</p>
      </div>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Response rate</h5>
        <p className={s.statNumber}>{responsesRate}</p>
      </div>
    </div>
  );
}

export default MessagingMeta;
